import { render, staticRenderFns } from "./MemberRights.vue?vue&type=template&id=05f564ae&scoped=true"
import script from "./MemberRights.vue?vue&type=script&lang=js"
export * from "./MemberRights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f564ae",
  null
  
)

export default component.exports